import React from "react";
import "../../styles.css";
import { useState, useEffect } from "react";

const PromptModal = ({
  title,
  type,
  handleClose,
  showModal,
  handleConsent,
  isLoading,
}) => {
  if (!showModal) {
    return null; // Return null if the modal is not open
  }
  const modalTypeRender = () => {
    switch (type) {
      case "binary":
        return (
          <>
            <button className="prompt-confirm-button" onClick={handleConsent}>
              Yes
            </button>
            <button className="prompt-deny-button" onClick={handleClose}>
              No
            </button>
          </>
        );
      case "alert":
        return (
          <>
            <button className="prompt-OK-button" onClick={handleClose}>
              OK
            </button>
          </>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="startTime-modal-overlay" onClick={handleClose}>
      {!isLoading ? (
        <div
          className="startTime-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="alert-modal-header">
            <h3>Notification</h3>
            <p>{title}</p>
          </div>
          <div className="prompt-modal-body">{modalTypeRender()}</div>
        </div>
      ) : (
        <>
          <img
            src={require("../../images/loading_icon.gif")}
            alt="Clock icon"
          />
        </>
      )}
    </div>
  );
};

export default PromptModal;
